import { defineProblems } from './Problems'

const commonProblems = defineProblems({
  /** What a request with no entry of its own reports, so it still says what to do. */
  UnexpectedFailure: {
    summary: 'Something went wrong',
    fix: 'Try again. If it keeps happening, reload the page and contact support.',
  },
  ImageUploadFailed: {
    summary: 'That image could not be uploaded',
    fix: 'Check the file is an image and try uploading it again.',
  },
  ImageLoadFailed: {
    summary: 'That image could not be loaded',
    fix: 'Reload the page to try again. The floor plan is still saved.',
  },
  BackgroundAudioLoadFailed: {
    summary: 'Failed to load background audio',
    fix: 'Reload the page to try again.',
  },
  InlineAudioLoadFailed: {
    summary: 'Failed to load inline audio',
    fix: 'Reload the page to try again.',
  },
  NodeTypesLoadFailed: {
    summary: 'Failed to load node types and categories',
    fix: 'Reload the page to try again. Your nodes are still saved.',
  },
  ToursLoadFailed: {
    summary: 'Failed to load tours',
    fix: 'Reload the page to try again.',
  },
  TourDeleteFailed: {
    summary: 'That tour could not be deleted',
    fix: 'Try again. App users still see the tour.',
  },
  TourSaveFailed: {
    summary: 'That tour could not be saved',
    fix: 'Try again. Your changes are still in the editor.',
  },
})

export { commonProblems }
